import React from 'react';
import '../../FormBuilder.css';

const QRMultiScanElement = ({ component, isRequired }) => {
  const renderElement = () => {
    return (
      component.elementName === 'qrMultiScan' && (
        <label className='titleTextLbl'>
            {component.fieldName || "QR Multi Scan"}
            <span className='requiredContainer' style={{ color: 'red' }}>{isRequired(component)}</span>
        </label>
      )
    );
  };

  return (
    <div className='renderAllElements'>
      {renderElement()}
    </div>
  );
};

export default QRMultiScanElement;
